import { useInView } from '@/hooks/reveal-in-view';
import { FC, useRef } from 'react';

import type { LeadGenTranslations } from '@/translations';
import type { ContentfulFileType } from '@/types';

import { Image } from '../image';
import SplitTextAnimation from '../split-text-animation';

interface Props {
  images: ContentfulFileType[];
  title: string;
  translation: LeadGenTranslations;
}

export const LeadGenHero: FC<Props> = ({ images, title, translation }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });

  return (
    <section className="lead-gen-hero" ref={ref}>
      <div className="lead-gen-hero--wrapper">
        <Image
          src={images[0] as any}
          alt={images[0].title}
          className="lead-gen-hero--bg lead-gen-hero--bg_xl"
        />
        <Image
          src={images[1] as any}
          alt={images[1].title}
          className="lead-gen-hero--bg lead-gen-hero--bg_lg"
        />
        <Image
          src={images[2] as any}
          alt={images[2].title}
          className="lead-gen-hero--bg lead-gen-hero--bg_sm"
        />
        <div className="lead-gen-hero--content">
          <SplitTextAnimation
            htmlElement={<h1 style={{ opacity: isInView ? 1 : 0 }}>{title}</h1>}
            isInView={isInView}
            className="lead-gen-hero--title"
          />
        </div>
      </div>

      <div
        className="lead-gen-hero--scroll-tip"
        style={{
          transform: isInView ? 'none' : `translateY(20px)`,
          opacity: isInView ? 1 : 0,
          transition: 'all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)',
        }}
      >
        <svg
          width="96"
          height="30"
          viewBox="0 0 96 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.7"
            y="0.7"
            width="18.6"
            height="28.6"
            rx="9.3"
            stroke="#87949E"
            strokeWidth="1.4"
          />
          <rect
            x="7.68828"
            y="7.43437"
            width="4.62211"
            height="8.73927"
            rx="2.31105"
            stroke="#87949E"
            strokeWidth="1.4"
          />
          <path d="M42 15L96 15" stroke="#87949E" />
        </svg>
        <span>{translation.hero.scroll}</span>
      </div>
    </section>
  );
};
